import { render, staticRenderFns } from "./IntegracaoDashboardComponent.vue?vue&type=template&id=bc015a4e&scoped=true"
import script from "./IntegracaoDashboardComponent.vue?vue&type=script&lang=js"
export * from "./IntegracaoDashboardComponent.vue?vue&type=script&lang=js"
import style0 from "./IntegracaoDashboardComponent.vue?vue&type=style&index=0&id=bc015a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc015a4e",
  null
  
)

export default component.exports